import { connect } from 'react-redux'
import { checkHideState } from 'Modules/searchFilters/actions'
import { FormFactory } from './FormFactory'

export default connect(state => ({ isMobileApp: state.app.isMobileApp }),
  { checkHideState })(FormFactory)
